import { Result } from '@/classes/Result'
import { fetchAPI } from '@/utils/useAPI'
import { IConversation, IEvent, IGroup, IPost, IUser } from '@/classes'
import { FetchFilters, FetchOptions } from '@/utils/useDataFetch'

export const usersSearchAPI = async (params: {
	filters: FetchFilters,
	options?: FetchOptions & {
		exclude?: string[]
	}
}, controller?: AbortController) => {
	const response: Result<{
		users: IUser[]
		count: number
	}> = await fetchAPI('users/search', params, { method: 'POST', controller })

	if (!response.ok) return { error: response.error, data: null, ok: false }
	
	return { data: response.data, ok: true }
}

export const usersGetCountAPI = async () => {
	const response: Result<{
		count: number,
		eventsPast: number,
		eventsFuture: number,
		members: number,
		groups: number
	}> = await fetchAPI('users/count')

	if (!response.ok) return { error: response.error, data: null, ok: false }
	
	return { data: response.data, ok: true }
}

export const subscribersGetAPI = async (params?: {
	exclude?: string[]
}) => {
	const response: Result<{
		users: IUser[]
		count: number
	}> = await fetchAPI('users/subscribed', params)

	if (!response.ok) return { error: response.error, data: null, ok: false }
	
	return { data: response.data, ok: true }
}

export const usersGetAPI = async (params: {
	filters: FetchFilters,
	options?: FetchOptions
}) => {
	const response: Result<{
		users: IUser[]
		count: number
	}> = await fetchAPI('users/get', params, { method: 'POST' })

	if (!response.ok) return { error: response.error, data: null, ok: false }
	
	return { data: response.data, ok: true }
}

export const usersFriendsGetAPI = async (params: {
	filters: FetchFilters,
	options?: FetchOptions
}, controller?: AbortController) => {
	const response: Result<{
		users: IUser[]
		count: number
	}> = await fetchAPI('users/friends', params, { method: 'POST', controller })

	if (!response.ok) return { error: response.error, data: null, ok: false }
	
	return { data: response.data, ok: true }
}

export const usersSuggestedGetAPI = async (params: {
	options?: FetchOptions
}, controller?: AbortController) => {
	const response: Result<{
		users: IUser[]
		count: number
	}> = await fetchAPI('users/suggested', params, { method: 'POST', controller })

	if (!response.ok) return { error: response.error, data: null, ok: false }
	
	return { data: response.data, ok: true }
}

export const usersFollowersGetAPI = async (
	params: {
		type: 'following' | 'followers'
		options?: FetchOptions
	},
	controller?: AbortController
) => {
	const response: Result<{
		users: IUser[]
		count: number
	}> = await fetchAPI('users/followers', params, { method: 'POST', controller })

	if (!response.ok) return { error: response.error, data: null, ok: false }
	
	return { data: response.data, ok: true }
}

export const userProfileGetAPI = async (params: {
	username?: string
	_id?: string
}) => {
	const response: Result<{
		user: IUser
		conversation: IConversation
		post: IPost | null
		groups: IGroup[]
		events: IEvent[]
		spicyCount: number
		users: IUser[]
	}> = await fetchAPI('users/profile', params, { method: 'POST' })

	return response
}